import type { HTMLProps, PropsWithChildren } from "react";
import cx from "classnames";

export function FormControl({
  children,
  className: additionalClassName,
  ...rest
}: PropsWithChildren & HTMLProps<HTMLDivElement>) {
  return (
    <div
      {...rest}
      className={cx("relative w-full mt-4 first:mt-0", additionalClassName)}
    >
      {children}
    </div>
  );
}
